import React, { useState } from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { data } from '../data';
import ShowMoreText from "react-show-more-text";
import styles from './resources.module.scss';

const CaseStudies = () => {
    const [isExpanded, setIsExpanded,] = useState(false);

    return (<>
        <Container className="outerContainer">
            <h1 className="centerText mb-4">Case Studies</h1>
            <p>This page provides information on how organizations, including hospitals and health systems, use the AHRQ QIs to improve the quality of care.</p>
            <h2 className="pt-5 centerText">Featured Case Studies</h2>
            {data.Resources.map((information, index) => (
                <div key={index}>
                    <Row>
                        {information.casestudies.map((info) => (<>
                            {info.category && info.category.includes('featured') ? (<>
                                <Col xs={12} md={6} className='stretchCard'>
                                    <Card className='mb-5 fullwidth'>
                                        <Card.Img variant="top" src={info.image} />
                                        <Card.Body>
                                            <Card.Title>{info.title}</Card.Title>
                                            <Card.Text>
                                                <h4>Organization At a Glance:</h4>
                                                <ShowMoreText
                                                    lines={3}
                                                    more='Read more'
                                                    less='Read less'
                                                    className='read-more'
                                                    anchorClass='my-anchor-css-class'
                                                    expanded={isExpanded}
                                                >
                                                    <div dangerouslySetInnerHTML={{ __html: info.organization }} className="mb-3" />
                                                </ShowMoreText>
                                            </Card.Text>
                                            <Button variant="primary" href={info.url}>View Case Study</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </>)
                                : null}
                        </>))}
                    </Row>
                </div>
            ))}
        </Container >
        <Container className="outerContainer pt-4">
            <h2 className="centerText">All Case Studies</h2>

            {data.Resources.map((information, index) => (
                <div key={index}>
                    {information.casestudies.map((info) => (<>
                        <Row id={info.id} className="mb-5 mt-5">
                            <Col md={4} className="mb-5 pr-5" >
                                <div className="mb-4">
                                    <img className="fullwidth" src={info.image} />
                                </div>
                                <Button className="fullwidth" href={info.url}>See Full Case Study</Button>
                            </Col>
                            <Col md={8}>
                                <h3>{info.title}</h3>
                                <h6>{info.date}</h6>
                                <>
                                    <ShowMoreText
                                        lines={5}
                                        more='Read more'
                                        less='Read less'
                                        className='read-more'
                                        anchorClass='my-anchor-css-class'
                                        expanded={isExpanded}
                                    >
                                        <h4>Organization At a Glance:</h4>
                                        <div dangerouslySetInnerHTML={{ __html: info.organization }} className="mb-3" />
                                        <h4>Improvement Opportunity:</h4>
                                        <p>{info.improvement}</p>
                                        {info.solution ?
                                            <>
                                                <h4>Solution:</h4>
                                                <p>{info.solution}</p>
                                            </>
                                            : null
                                        }
                                        <h4>Results:</h4>
                                        <div dangerouslySetInnerHTML={{ __html: info.result }} />
                                    </ShowMoreText>
                                </>
                            </Col>
                        </Row>
                        <hr />
                    </>))}
                </div>
            ))}
            <div className={"centerText" + ' ' + styles.blueBox} >
                <h4>How does your organization use the AHRQ QIs to improve quality of care?</h4>
                <p className="mb-0">Share your story by contacting the AHRQ QI Support Team at</p>
                <a href="mailto: QIsupport@ahrq.hhs.gov">QIsupport@ahrq.hhs.gov</a>
            </div>
        </Container>
    </>)
}

export default CaseStudies;